import React, { memo, useEffect, useState } from 'react';
import { Mention, MentionsInput } from 'react-mentions';
import { mentionTagsStyles } from 'constants';
import { useGetHashtagsQuery, useGetMentionUsersQuery } from 'services';
import useTranslate from 'hooks/useTranslate';

interface MentionsComponentProps {
	formik?: any;
	fieldName: string;
	contentValue?: string;
	textAreaId?: string;
}

const MentionsComponent: React.FC<MentionsComponentProps> = ({
	formik = {},
	fieldName,
	contentValue = '',
	textAreaId = '',
}) => {
	const { translate } = useTranslate();
	const searchString =
		'order=DESC&hasExpired=false&inActive=false&type=all&socialPostType=all&connectionType=connected';
	const { data: { docs: hashtagList = [] } = {} } = useGetHashtagsQuery(searchString);
	const { data: { docs: mentionUsers = [] } = {} } = useGetMentionUsersQuery(searchString);

	const [transformedHashtagList, setTransformedHashtagList] = useState<any>([]);
	const [transformedUserList, setTransformedUserList] = useState<any>([]);

	useEffect(() => {
		if (contentValue) formik.setFieldValue(fieldName, contentValue);
	}, [contentValue]);

	useEffect(() => {
		if (hashtagList?.length > 0) {
			setTransformedHashtagList(
				hashtagList?.map((tag: any) => ({
					id: tag.id,
					display: tag.name,
				})),
			);
		} else {
			setTransformedHashtagList([]);
		}
	}, [hashtagList]);

	useEffect(() => {
		if (mentionUsers?.length > 0) {
			setTransformedUserList(
				mentionUsers?.map((tag: any) => ({
					id: tag?.id,
					display: tag?.name,
					userType: tag?.userType,
				})),
			);
		} else {
			setTransformedUserList([]);
		}
	}, [mentionUsers]);

	const handleCommentChange = (e: any) => {
		formik.setFieldValue(fieldName, e.target.value);
		const value = e.target.value;

		const hashtagFindRegex = /(^|\s)(#[a-z\d-_]+)/gi;
		const foundTags = value.match(hashtagFindRegex);

		if (foundTags) {
			const newTags = foundTags
				.map((tag: any) => tag.trim().substring(1))
				.filter((tag: any) => !transformedHashtagList.some((ht: any) => ht.display === tag));
			if (newTags.length > 0) {
				const newHashtags = newTags.map((tag: any) => ({
					id: `new-${tag}`,
					display: tag,
				}));
				setTransformedHashtagList((prevList: any) => [...prevList, ...newHashtags]);
			}
		}
	};

	/* const onAddHasgtag = () => {
		if (hashtagList?.length > 0) {
			setTransformedHashtagList(
				hashtagList?.map((tag: any) => ({
					id: tag.id,
					display: tag.name,
				})),
			);
		} else {
			setTransformedHashtagList([]);
		}
	};

	const onAddUser = () => {
		if (mentionUsers?.length > 0) {
			setTransformedUserList(
				mentionUsers?.map((tag: any) => ({
					id: tag.id,
					display: tag.name,
					userType: tag?.userType,
				})),
			);
		} else {
			setTransformedUserList([]);
		}
	}; */

	return (
		<MentionsInput
			value={formik.values?.[fieldName]}
			placeholder={translate('Social.addCommentUseTag')}
			onChange={handleCommentChange}
			style={mentionTagsStyles}
			className="create-new-post-content-inner"
			id={textAreaId}
		>
			<Mention
				trigger="@"
				data={transformedUserList}
				className="mentions__user"
				// onAdd={onAddUser}
				appendSpaceOnAdd={true}
				markup="@[__display__](__id__)"
			/>
			<Mention
				trigger="#"
				className="mentions__tag"
				data={transformedHashtagList}
				// onAdd={onAddHasgtag}
				appendSpaceOnAdd={true}
				markup="#[__display__](__id__)"
				displayTransform={(id, display) => `#${display}`}
			/>
		</MentionsInput>
	);
};

export default memo(MentionsComponent);
